import React from 'react'
import InfoModal from '../../components/InfoModal';

const gameModeDescriptions = ["鬼が逃走者を捕まえると、逃走者は鬼に代わり、鬼は逃走者になります。（役を交代します）", "逃走者が鬼に捕まると、新しく鬼になります。既存の鬼はずっと鬼のままです。"];
// eslint-disable-next-line no-unused-vars -- AI用追加情報の選択UI（コメントアウト中）を有効化する際に使用する選択肢一覧
const conceptsOptions = ['学生向け', '家族向け', '子ども向け', '大人向け', 'かんたん', 'ハード', 'マニアック', '鉄道好き', '自然好き', '歴史好き', '食べ物', '観光地'];

const BasicInfoTab = ({
    name, setName, detail, setDetail, publicCheck, setPublic, auto, setAuto,
    startTime, setStartTime, prepareLimitTime, setPrepareLimitTime, endTime, setEndTime,
    lat, setLat, lng, setLng, zoom, setZoom, gameLocation, setGameLocation, gameMode, setGameMode,
    activated, deleting, gameID, activeChangeAlltimeBtn, setActiveChangeAlltimeBtn, oldStartTime,
    triggerAutoSave, getLatLngFromLocation, changeAllTime, deleteGame
}) => {
    return (
        <div className='lg:grid lg:grid-cols-2'>
            <div className='mb-6 mx-3'>
                <div className='mb-6'>
                    <label>ゲーム名</label>
                    <input value={name} onChange={(e) => {setName(e.target.value); triggerAutoSave();}} type="text" maxLength={20} className="w-full p-2 border rounded-lg mb-4 focus:outline-purple-300" />

                    <label>概要</label>
                    <textarea value={detail} onChange={(e) => {setDetail(e.target.value); triggerAutoSave();}} className="w-full p-2 border rounded-lg mb-4 focus:outline-purple-300" rows="4"></textarea>

                    <div className='rounded-lg bg-white p-2 inline-block pe-6'>
                        <input checked={publicCheck} onChange={(e) => setPublic(e.target.checked)} type="checkbox" className="m-2 w-4 h-4 align-middle" id="openCheck" /><label htmlFor='openCheck' className='text-lg align-middle'>参加登録を受付</label><br />
                        <p className='text-gray-500 text-sm ms-7'>ゲームIDを入力してもらうことで、参加者として登録されます</p>
                    </div>
                </div>

                <div className='mb-6'>
                    <h2 className='text-lg mb-2 text-purple-700'><i className='bi bi-map me-2'></i>マップ</h2>
                    <p className='text-sm text-gray-600 ms-2 mb-3'>マップの中心座標</p>

                    <label>開催地</label>
                    <input value={gameLocation} onChange={(e) => {setGameLocation(e.target.value); triggerAutoSave();}} type="text" className="w-full p-2 border rounded-lg mb-4 focus:outline-purple-300" />

                    {/* 開催地名が入力されている場合、座標の自動入力ボタンを表示 */}
                    {gameLocation && (
                        <div className='text-end mb-4'>
                            <button type='button' className='text-purple-700 underline' onClick={() => getLatLngFromLocation()}><i className='bi bi-geo-alt me-1'></i>座標を自動入力</button>
                        </div>
                    )}

                    <div className='grid grid-cols-8 gap-3'>
                        <div className='col-span-3'>
                            <label>緯度</label>
                            <input type="number" value={lat} onChange={(e) => {setLat(e.target.value); triggerAutoSave();}} placeholder='35.6895' className="w-full p-2 border rounded-lg mb-4 focus:outline-purple-300" />
                        </div>

                        <div className='col-span-3'>
                            <label>経度</label>
                            <input  type="number" value={lng} onChange={(e) => {setLng(e.target.value); triggerAutoSave();}} placeholder='139.7514' className="w-full p-2 border rounded-lg mb-4 focus:outline-purple-300" />
                        </div>

                        <div className='col-span-2'>
                            <label>拡大率</label>
                            <input  type="number" value={zoom} onChange={(e) => {setZoom(e.target.value); triggerAutoSave();}} placeholder='12' className="w-full p-2 border rounded-lg mb-4 focus:outline-purple-300" />
                        </div>
                    </div>

                    {/* 座標が入力されている場合、Google Mapでピンを立てて確認するためのリンクを表示 */}
                    {lat && lng && (
                        <div className='text-end mb-4'>
                            <a href={`https://maps.google.com/maps?ll=${lat},${lng}&z=${zoom}&q=${lat},${lng}`} target="_blank" rel="noopener noreferrer" className='text-purple-700 underline'><i className='bi bi-map me-1'></i>Google Mapで確認</a>
                        </div>
                    )}
                </div>

                {/* ゲームの削除 */}
                {
                    gameID && (
                        <div className='text-center my-5'>
                            <button type='button' disabled={deleting} className='text-red-600 py-2 px-4 rounded-lg hover:bg-red-400/10 disabled:opacity-50' onClick={() => deleteGame()}><i className='bi bi-trash me-2'></i>ゲームを削除</button>
                        </div>
                    )
                }
            </div>

            <div className='mb-6 mx-3'>
                <h2 className='text-lg mb-2 text-purple-700'><i className='bi bi-clock me-2'></i>時間</h2>

                <div className='rounded-lg bg-white p-1 inline-block pe-6 m-2'>
                    <input checked={auto} onChange={(e) => setAuto(e.target.checked)} type="checkbox" className="m-2 w-4 h-4 align-middle" id="autoCheck" /><label htmlFor='autoCheck' className='text-lg align-middle'>自動で実行</label>
                    <InfoModal>
                        <p className='text-gray-700 mb-2'>設定した時刻にゲームが開始・終了され、ミッションが発令されます</p>
                        <p className='text-red-600'>注: 「自動で実行」がオフの場合、開始～終了時刻に限り、ゲームを実行できます</p>
                    </InfoModal>
                </div>
                <br />

                {activated && (
                    <div className='rounded-lg bg-red-100 text-red-700 p-2 m-2 border border-red-300 shadow-sm'><i className='bi bi-exclamation-triangle mx-1'></i>アクティベート済みのため、時刻の変更はできません</div>
                )}


                <div className='mb-4'>
                    <label>開始時刻</label>
                    <input value={startTime} disabled={activated} onChange={(e) => {setActiveChangeAlltimeBtn(true);setStartTime(e.target.value); triggerAutoSave();}} type="datetime-local" className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" />

                    {/* 全ての時間をずらすボタン */}
                    { (activeChangeAlltimeBtn && oldStartTime) && (
                        <div className='text-end'>
                            <button className='text-sm underline text-purple-700' onClick={() => changeAllTime()}><i className='bi bi-clock me-1'></i>全ての時間をずらす</button>
                        </div>
                    )}
                </div>


                <label>逃走者の準備終了時刻</label>
                <input value={prepareLimitTime} disabled={activated || !auto} onChange={(e) => {setPrepareLimitTime(e.target.value); triggerAutoSave();}} type="datetime-local" className="w-full p-2 border rounded-lg mb-4 focus:outline-purple-300" />

                <label>終了時刻</label>
                <input value={endTime} disabled={activated} onChange={(e) => {setEndTime(e.target.value); triggerAutoSave();}} type="datetime-local" className="w-full p-2 border rounded-lg mb-4 focus:outline-purple-300" />


                {/* AIのための追加情報 */}
                {/* <h2 className='text-lg mb-2 text-purple-700'><i className='bi bi-stars me-2 text-lime-500'></i>AIのための追加情報</h2>

                <label>コンセプト</label><br/>
                {
                    conceptsOptions.map((concept, index) => {
                        return (
                            <Checkbox key={index} id={"concept_" + index} label={concept} checked={gameConcepts[index]} onChange={(e) => {
                                const newConcepts = [...gameConcepts];
                                newConcepts[index] = e.target.checked;
                                setGameConcepts(newConcepts);
                            }} />
                        )
                    })
                } */}

                {/* 基本ルール（代わり鬼 or 増やし鬼 の選択） */}
                <h2 className='text-lg mb-2 text-purple-700'><i className='bi bi-journal-check me-2'></i>基本ルール</h2>

                <div className='rounded-lg bg-white p-2 m-2 w-full'>
                    <div className='grid grid-cols-2 mb-2'>
                        <div>
                            <input type="radio" name="gameMode" id="gameMode1" checked={gameMode === 0} onChange={() => setGameMode(0)} className="m-2 w-4 h-4 align-middle" />
                            <label htmlFor='gameMode1' className='text-lg align-middle'>代わり鬼</label>
                        </div>
                        <div>
                            <input type="radio" name="gameMode" id="gameMode2" checked={gameMode === 1} onChange={() => setGameMode(1)} className="m-2 w-4 h-4 align-middle" />
                            <label htmlFor='gameMode2' className='text-lg align-middle'>増やし鬼</label>
                        </div>
                    </div>

                    <p className='text-gray-600 text-sm p-2'>{gameModeDescriptions[gameMode]}</p>

                    {/* スコアルールの説明 */}
                    <p className='text-gray-700 text-sm p-2'>
                        <i className='bi bi-info-circle me-1'></i>
                        捕まえたら +100pt、捕まったら -100pt
                    </p>
                </div>
            </div>
        </div>
    )
}

export default BasicInfoTab
